export const APP_IMAGES = {
  logo: "/images/logo-green.png",
  logoWhite: "/images/logo.png",
  // logoGreen: "/images/logo-green-old.png",
  timeOff: "/images/time-off.svg",
  filter: "/images/filter.svg",
  mofaPin: "/images/mofa-pin.png",
  noPhotoAvailable: "/images/no-photo-available.jpg",
  printBg: "/images/print-bg.svg",
};
